import type {Primitive,CoordinateDisplay} from './graph-primitives';
import {fmt} from './interactive-graph-model';
import type {Axis} from './graph-geometry';
import type {XY} from './graph-geometry';
export type Crosshair=Extract<Primitive,{kind:'crosshair'}>;
// Rendering policy is separate from resolution: hidden coordinates remain usable
// by projections, intervals and scalar dependencies, without becoming labels.
export function crosshairDisplay(p:Crosshair,showValues:boolean,correction=false):CoordinateDisplay {
 const fallback=p.constraint==='vertical'?'x':p.constraint==='horizontal'?'y':'both';
 return correction?(p.correctionCoordinates??fallback):(p.coordinates??(showValues?fallback:'none'));
}
export function moveCrosshair(p:Crosshair,to:XY):Crosshair {
 if(p.movable===false)return p;
 return {...p,x:p.constraint!=='horizontal'&&typeof p.x==='number'&&Number.isFinite(to.x)?to.x:p.x,y:(p.constraint==='free'||p.constraint==='horizontal')&&typeof p.y==='number'&&Number.isFinite(to.y)?to.y:p.y};
}
export function crosshairMovable(p:Crosshair){return p.movable!==false&&((p.constraint!=='horizontal'&&typeof p.x==='number')||((p.constraint==='free'||p.constraint==='horizontal')&&typeof p.y==='number'));}

// One display formatter shared by the SVG and construction inspector.
export function crosshairCoordinate(p:Crosshair,axis:Pick<Axis,'symbol'|'quantity'|'unit'>|undefined,dimension:'x'|'y',value:number):string {
 const symbol=axis?.symbol.trim()||axis?.quantity.trim()||dimension;
 const unit=axis?.unit.trim();
 const fixed=typeof p.precision==='number'&&Number.isInteger(p.precision)&&p.precision>=0&&p.precision<=12;
 const formatted=fixed&&Number.isFinite(value)?value.toLocaleString('fr-FR',{minimumFractionDigits:p.precision as number,maximumFractionDigits:p.precision as number}):fmt(value);
 return `${symbol} = ${formatted}${unit?` ${unit}`:''}`;
}
